import { createSelector } from '@reduxjs/toolkit';
import type {
  AutoConfiguratorState,
  Field,
  FieldId,
} from '@snap-types/models/auto-configurator/state';
import { getField } from '@ui/features/alpha/logic/field';

export function selectField(state: AutoConfiguratorState, fieldId: FieldId) {
  return getField(state, fieldId);
}

export const selectFields = createSelector(
  [
    (state: AutoConfiguratorState) => state.fields,
    (_state: AutoConfiguratorState, fieldIds: FieldId[]) => fieldIds,
  ],
  (fields, fieldIds): Field[] =>
    fieldIds.map((fieldId) => {
      const field =
        fieldId.model === 'lineItem'
          ? fields.lineItem[fieldId.key]
          : fields.quantityBreak[fieldId.key];

      if (!field) {
        throw new Error(
          `No field found for model "${fieldId.model}" and key "${fieldId.key}"`,
        );
      }

      return field;
    }),
);
